/* eslint-disable react/forbid-dom-props */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Checkbox, IconButton, Modal, PrimaryButton, Text } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import { InstructionsModalBody } from './instructionsModalBody';
import { Constants } from '@shared/utils/constants';
import { saveLocalStorageItem } from '@shared/utils/browserStorageUtils';
import { getNpsModule } from '@appsource/utils/nps';
const cancelIcon = {
    iconName: 'Cancel'
};
export const InstructionsModal = ({ context, isFromDownload, dismissModal })=>{
    const [isModalOpen, { setFalse: hideModal }] = useBoolean(true);
    const [isChecked, setIsChecked] = React.useState(false);
    const closeModal = ()=>{
        var _getNpsModule;
        if (isFromDownload && isChecked) {
            saveLocalStorageItem(Constants.LocalStorage.dontShowInstructions, true);
        }
        hideModal();
        dismissModal();
        (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.ctaClicked();
    };
    return /*#__PURE__*/ _jsx(Modal, {
        containerClassName: "instructionsModalContainer",
        isOpen: isModalOpen,
        onDismiss: closeModal,
        children: /*#__PURE__*/ _jsxs("div", {
            role: "dialog",
            "aria-label": "instructionsModal",
            className: "instructionsModalClass",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "toolBar",
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            className: "instructionsHeader",
                            children: context.loc('PowerBIVisual_Instructions_Header')
                        }),
                        /*#__PURE__*/ _jsx(IconButton, {
                            "aria-label": "close",
                            className: "cancel",
                            iconProps: cancelIcon,
                            onClick: closeModal
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "instructionsText",
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: context.locParams('PowerBIVisual_Instructions_Intro', [
                            `<a class='c-hyperlink' rel='noreferrer' target='_blank' href=${Constants.PowerBIVisualInstructionsUrl}>${context.loc('PowerBIVisual_Instructions')}</a>`
                        ])
                    }
                }),
                /*#__PURE__*/ _jsx(InstructionsModalBody, {
                    context: context
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "instructionsFooter",
                    children: [
                        isFromDownload && /*#__PURE__*/ _jsx(Checkbox, {
                            className: "instructionsCheckbox",
                            label: context.loc('Dialog_Dont_Show_Again'),
                            checked: isChecked,
                            onChange: ()=>setIsChecked(!isChecked)
                        }),
                        /*#__PURE__*/ _jsx(PrimaryButton, {
                            name: "button",
                            type: "submit",
                            onClick: closeModal,
                            children: context.loc('Dialog_Close')
                        })
                    ]
                })
            ]
        })
    });
};
